import React from "react";
import { Modal, Box, Typography, Button } from "@mui/material";
import { ReactComponent as Warning } from "assets/Warning.svg";
import { useTranslation } from "react-i18next";

const ExportConfirmModal = ({ open, selectedFields, onClose, onConfirm }) => {
  const { t } = useTranslation();

  return (
    <Modal
      open={open}
      onClose={onClose}
      aria-labelledby="template-download-warning"
      aria-describedby="template-download-warning-description"
    >
      <Box
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          backgroundColor: "white",
          borderRadius: "10px",
          padding: "30px 10px",
          maxWidth: "400px",
          width: "90%",
          textAlign: "center",
          boxShadow: "0 10px 25px rgba(0, 0, 0, 0.2)",
          outline: "none",
        }}
      >
        <Box sx={{ mb: "-30px" }}>
          <Warning
            style={{ width: "161px", height: "149px", margin: "0 auto" }}
          />
        </Box>

        {/* Warning Message */}
        <Typography
          id="template-download-warning-description"
          sx={{
            color: "#333",
            fontSize: "16px",
            lineHeight: 1.5,
            fontFamily: "Montserrat",
            fontWeight: 500,
            maxWidth: "300px",
            margin: "0 auto",
          }}
        >
          {selectedFields
            ? `Are you sure you want to export ${selectedFields} records?`
            : t("reports.exportModalDescription")}
        </Typography>

        <Box sx={{ display: "flex", justifyContent: "center", mt: 2 }}>
          <Box
            sx={{
              display: "flex",
              width: "67%",
              justifyContent: "space-around",
            }}
          >
            <Button
              onClick={onClose}
              sx={{
                backgroundColor: "gray",
                color: "white",
                borderRadius: "10px",
                padding: "7px 26px",
                fontSize: "16px",
                fontWeight: "500",
                textDecoration: "",
                fontFamily: "Montserrat",
                minWidth: "100px",
                "&:hover": {
                  backgroundColor: "lightgray",
                },
                boxShadow: "0px 4px 12px rgba(0, 0, 0, 0.2)",
              }}
            >
              {t("reports.no")}
            </Button>

            <Button
              onClick={onConfirm}
              sx={{
                backgroundColor: "#EF7D00",
                color: "white",
                borderRadius: "10px",
                padding: "7px 26px",
                fontSize: "16px",
                fontWeight: "500",
                fontFamily: "Montserrat",
                minWidth: "100px",
                "&:hover": {
                  backgroundColor: "#d66d00",
                },
                boxShadow: "0px 4px 12px rgba(0, 0, 0, 0.2)",
              }}
            >
              {t("reports.yes")}
            </Button>
          </Box>
        </Box>
      </Box>
    </Modal>
  );
};

export default ExportConfirmModal;
